import React, { useContext, useState } from 'react'
import { useHistory } from 'react-router-dom'
import Modal from 'react-modal'
import { Popover } from '@material-ui/core'
import { useKeycloak } from '@react-keycloak/web'
import { MoreVert, FileCopy, People, Apartment, Delete, ListAlt, Person } from '@material-ui/icons'

import searchPageContext from '../../FiltersComponent/context/context'
import { getUserSFId } from '../../Utility/Utility'
import { sortArray } from '../../../PropertyList/Utility/PropertyListUtility'
import SearchSavedSearch from '../SearchSavedSearch/SearchSavedSearch'
import ClonePropertyList from '../../../PropertyList/HeadBar/ListOptions/ClonePropertyList/ClonePropertyList'
import DeletePropertyList from '../../../PropertyList/HeadBar/ListOptions/DeletePropertyList/DeletePropertyList'

const SelectExistingList = props => {
    const [anchorEl, setAnchorEl] = useState(null)
    const history = useHistory()
    const { keycloak } = useKeycloak()
    const [modalIsOpen, setIsOpen] = useState(false)
    const [inputSearchSaved, setInputSearchSaved] = useState('')
    // let [checkedSavedSearch, setCheckedSavedSearch] = useState(undefined)
    let { savedLists, setSelectedMenu } = useContext(searchPageContext)
    const [selectedOption, setSelectedOption] = useState('')
    const [listData, setListData] = useState()
    const [showDeleteOption, setShowDeleteOption] = useState(false)
    const [showOwnList, setShowOwnList] = useState(true)
    const [showSharedList, setShowSharedList] = useState(true)
    const [disableClose, setdisableClose] = useState(false)
    // useEffect(() => {
    //     console.log('searchTerm = ', getQueryStringValue('searchTerm'))
    //     setInputSearchSaved(getQueryStringValue('searchTerm') ? getQueryStringValue('searchTerm') : '')
    // }, [getQueryStringValue('searchTerm')]);

    const handleClick = selectedList => {
        try {

            const href = window.location.href
            let queryParam = href.split('?')[1] ? href.split('?')[1] : ''
            let listId = selectedList.polarisPropertySearchCriteriaId

            let ov_listId = selectedList.omniViewPropertyListId

            queryParam = queryParam.replace('&view=savedList', '')
            queryParam = queryParam.replace('view=savedList', '')

            queryParam += `&list_id=${listId}&list_ov_id=${ov_listId}`

            history.push({ pathname: '/PropertyList', search: queryParam })

            setSelectedMenu('list')

        } catch (e) {
            console.log('Error ::: ', e)
        }
    }

    // const getSavedListsCount = () => {

    //     // let count = 0
    //     // if (inputSearchSaved) {
    //     //     count = savedLists.filter(x => x.isCart && x.name.toLowerCase().includes(inputSearchSaved.toLowerCase())).length
    //     // } else {
    //     //     count = savedLists.filter(x => x.isCart).length
    //     // }
    //     return `Your Lists (${count})`
    // }

    const getTotalCount = () => {
        return savedLists.length
    }

    // const getListsCount = param => {
    //     let returnVal = []

    //     if (param === 'own') {
    //         returnVal = savedLists.filter(x => x.isCart && ((getUserSFId() === x.omniViewUserId && x.omniViewUserId && getUserSFId()) || (x.userId === keycloak.subject && x.userId)) && x.name.toLowerCase().includes(inputSearchSaved.toLowerCase())).length
    //     } else {
    //         returnVal = savedLists.filter(x => x.isCart && ((getUserSFId() !== x.omniViewUserId && x.omniViewUserId && getUserSFId()) || (x.userId !== keycloak.subject && x.userId)) && x.name.toLowerCase().includes(inputSearchSaved.toLowerCase())).length
    //     }

    //     return returnVal

    // }

    // const getSavedList = () => {
    //     if (inputSearchSaved) {
    //         return savedLists.filter(x => x.isCart && x.name.toLowerCase().includes(inputSearchSaved.toLowerCase()))
    //     } else {
    //         return savedLists.filter(x => x.isCart)
    //     }
    // }

    const getSavedList = () => {
        let returnVal = []
        if (showOwnList) {
            returnVal = savedLists.filter(x => x.isCart && (x.omniViewUserId && getUserSFId() && getUserSFId() === x.omniViewUserId) && x.name.toLowerCase().includes(inputSearchSaved.toLowerCase()))
        }

        if (showSharedList) {
            returnVal = [...returnVal, ...savedLists.filter(x => x.isCart && (x.omniViewUserId && getUserSFId() && getUserSFId() !== x.omniViewUserId) && x.name.toLowerCase().includes(inputSearchSaved.toLowerCase()))]
        }

        return sortArray(returnVal, 'lastModifiedDate', 'desc')

    }

    const handleChange = e => {
        const { value } = e.target
        setInputSearchSaved(value)
    }

    const getPropertyCount = list => {
        let count = 0

        if (list.compsList) {
            count = list.compsList.length
        }

        return count
    }

    const getOwnerName = list => {
        let name = ''

        if (list.polarisUserName) {
            name = list.polarisUserName
        }

        if (!name && list.omniViewUserName) {
            name = list.omniViewUserName
        }

        return name
    }

    const getLastModifiedDate = lastModifiedDate => {
        let dt = '-'

        if (lastModifiedDate) {
            var options = { year: 'numeric', month: 'short', day: 'numeric' }
            dt = new Intl.DateTimeFormat('en-US', options).format(new Date(lastModifiedDate))
        }

        return dt
    }
    const handleShowOptions = (event, value) => {
        setShowDeleteOption(showDeleteIcon(value))
        setListData(value)
        setAnchorEl(event.currentTarget)
    }

    const handleClose = () => {
        setAnchorEl(null)
    }
    function openModal(inpuVal) {

        setSelectedOption(inpuVal)
        setIsOpen(true)
        handleClose()
    }

    function closeModal() {
        if (!disableClose) {
            setIsOpen(false)
        }
    }

    // const getRecentList = () => {

    //     let recentList = sortArray(savedLists, 'lastModifiedDate', 'desc')

    //     if (recentList.length > 4) {
    //         recentList = recentList.slice(0, 4)
    //     }

    //     return recentList
    // }

    const getPropPicture = value => {

        let propPicture = ''

        if (value) {
            let compsList = value.compsList.filter(x => x.isSubjectProperty)

            if (compsList.length) {
                compsList.forEach(element => {
                    if (!propPicture) {
                        if (element.omniViewUserId === "a13a0000007gtuvAAA") {
                            debugger
                        }
                        propPicture = element.propPicture ? element.propPicture : ''
                    }
                })
            }
        }
        // console.log('value = ', value)
        return propPicture
    }

    // const recentListCard = value => {

    //     const getPropPicture = () => {

    //         let propPicture = ''

    //         let compsList = value.compsList.filter(x => x.isSubjectProperty)

    //         if (compsList.length) {
    //             compsList.forEach(element => {
    //                 if (!propPicture) {
    //                     propPicture = element.propPicture ? element.propPicture : ''
    //                 }
    //             })
    //         }

    //         return propPicture
    //     }

    //     return (
    //         <>
    //             <div onClick={() => { handleClick(value) }} className="col-span-1 border-1 border-base overflow-hidden cursor-pointer shadow-3">
    //                 <div className="flex flex-col">
    //                     <div className="flex items-center justify-center">
    //                         <div className="w-full m-4">
    //                             {getPropPicture() ?
    //                                 <img src={getPropPicture()} style={{ 'width': '100%', 'height': '150px' }} />
    //                                 :
    //                                 <div className="w-full" style={{ 'height': '150px', 'max-width': '100%', 'position': 'relative' }}>
    //                                     <div className="w-full h-full bg-gray-10">
    //                                         <span className="absolute" style={{ 'top': 'calc(50% - 24px/2)', 'left': 'calc(50% - 24px/2)' }}>
    //                                             <Apartment color="disabled" fontSize="large" />
    //                                         </span>
    //                                     </div>
    //                                 </div>
    //                             }
    //                         </div>
    //                     </div>
    //                     <div className="px-4 py-2">{value.name}</div>
    //                 </div>
    //             </div>
    //         </>
    //     )
    // }

    const showDeleteIcon = item => {
        let returnVal = false

        if (item.userId && item.userId === keycloak.subject) {
            returnVal = true
        }

        if (!returnVal && item.omniViewUserId && item.omniViewUserId === getUserSFId()) {
            returnVal = true
        }

        return returnVal
    }

    const customStyles = {
        content: {
            top: '30%',
            left: '50%',
            right: 'auto',
            bottom: 'auto',
            marginRight: '-50%',
            transform: 'translate(-50%, -40%)',
            padding: '0px !important'
        },
        overlay: { zIndex: 1050 }
    }

    const open = Boolean(anchorEl)

    return (
        <>
            <div className="grid grid-cols-1 md:grid-cols-12">
                <div className="overflow-hidden ">

                </div>
                <div className="md:col-span-9 overflow-hidden ">
                    <div data-testid="test-div-update-save-search" className="flex flex-col pt-4">
                        <div className="flex flex-row border-b-1 border-base pb-4">
                            <SearchSavedSearch handleChange={handleChange} inputSearchSaved={inputSearchSaved} setInputSearchSaved={setInputSearchSaved} ></SearchSavedSearch>
                            {/* <SearchSavedSearch /> */}
                        </div>
                        <div className="flex flex-row py-4 px-2 font-medium">
                            Your Recent lists
                        </div>
                        <div className="border-b-1 border-base pb-4">
                            <div className="grid grid-cols-2 md:grid-cols-4 gap-4">
                                {savedLists.slice(0, 4).map(value => (
                                    // recentListCard(value)
                                    <div onClick={() => { handleClick(value) }} className="col-span-1 border-1 border-base overflow-hidden cursor-pointer shadow-3">
                                        <div className="flex flex-col">
                                            <div className="flex items-center justify-center">
                                                <div className="w-full m-4">
                                                    {getPropPicture(value) ?
                                                        <img src={getPropPicture(value)} style={{ 'width': '100%', 'height': '150px' }} />
                                                        :
                                                        <div className="w-full" style={{ 'height': '150px', 'max-width': '100%', 'position': 'relative' }}>
                                                            <div className="w-full h-full bg-gray-10">
                                                                <span className="absolute" style={{ 'top': 'calc(50% - 24px/2)', 'left': 'calc(50% - 24px/2)' }}>
                                                                    <Apartment color="disabled" fontSize="large" />
                                                                </span>
                                                            </div>
                                                        </div>
                                                    }
                                                </div>
                                            </div>
                                            <div className="px-4 py-2">{value.name}</div>
                                        </div>
                                    </div>
                                ))}
                            </div>
                        </div>
                        <div className="flex justify-between border-b-1 border-base pt-6 pb-3">
                            {/* <span className="px-2 font-medium">
                                {getSavedListsCount()}
                            </span> */}
                            <div className="flex flex-col">
                                {/* <div className="flex flex-row space-x-4">
                                    <span>
                                        <input data-testid="test-chk-own-list" onChange={() => { setShowOwnList(!showOwnList) }} checked={showOwnList} id="chk-own-list" name="chk-own-list" type="checkbox" />
                                        <label className="px-3 " htmlFor="chk-own-list">Own List - {getListsCount('own')}</label>
                                    </span>
                                    <span>
                                        <input data-testid="test-chk-shared-list" onChange={() => { setShowSharedList(!showSharedList) }} checked={showSharedList} id="chk-shared-list" name="chk-shared-list" type="checkbox" />
                                        <label className="px-3 " htmlFor="chk-shared-list">Shared List - {getListsCount('shared')}</label>
                                    </span>
                                </div> */}
                                <div className="flex flex-row space-x-4">
                                    <span>
                                        <span data-testid="test-chk-own-list" onClick={() => setShowOwnList(!showOwnList)} className={`items-center capitalize cursor-pointer badge rounded-pill px-5 mr-3 mb-4 py-3 border-1 border-base ${showOwnList ? 'text-primary bg-gray-10' : 'bg-white'}`}>
                                            <Person fontSize="small" />
                                            <span className="pl-3">Own List</span>
                                            {/* <span className="pl-3">Own List - {getListsCount('own')}</span> */}
                                        </span>
                                    </span>
                                    <span>
                                        <span data-testid="test-chk-shared-list" onClick={() => setShowSharedList(!showSharedList)} className={`items-center capitalize cursor-pointer badge rounded-pill px-5 mr-3 mb-4 py-3 border-1 border-base ${showSharedList ? 'text-primary bg-gray-10' : 'bg-white'}`}>
                                            <People fontSize="small" />
                                            <span className="pl-3">Shared List</span>
                                            {/* <span className="pl-3">Shared List - {getListsCount('shared')}</span> */}
                                        </span>
                                    </span>
                                </div>

                            </div>
                            <div>
                                Total {getTotalCount()} Lists
                            </div>
                        </div>
                        <div className="border-1 border-base flex flex-col overflow-y-auto disable-scrollbars mb-4">
                            {getSavedList().map(value => (
                                <>
                                    <div className="grid grid-cols-6 border-b-1 space-x-3 border-base hover:bg-gray-15 items-center py-3 text-2">
                                        <div onClick={() => { handleClick(value) }} key={value.name} className="text-base col-span-2 px-3 cursor-pointer">
                                            <div className="flex flex-row">
                                                <div>
                                                    <ListAlt></ListAlt>
                                                </div>
                                                <div className="px-3 font-medium">
                                                    {value.name}
                                                </div>
                                            </div>
                                        </div>
                                        <div className="col-span-1 flex flex-col">
                                            <div className="font-medium">
                                                {getOwnerName(value)}
                                            </div>
                                            <div className="text-muted text-1 py-1">Owner</div>
                                        </div>
                                        <div className="col-span-1 flex flex-col">
                                            <div className="font-medium">
                                                {getLastModifiedDate(value.lastModifiedDate)}
                                            </div>
                                            <div className="text-muted text-1 py-1">Last Modified</div>
                                        </div>
                                        <div className="col-span-1 flex flex-col">
                                            <div className="font-medium">
                                                {getPropertyCount(value)}
                                            </div>
                                            <div className="text-muted text-1 py-1">Total Properties</div>
                                        </div>
                                        <div className="flex justify-center">
                                            <button data-testid="test-btn-show-list-options" className="p-1 btn "
                                                onClick={event => { handleShowOptions(event, value) }} >
                                                <MoreVert fontSize="small"></MoreVert>
                                            </button>
                                        </div>
                                    </div>
                                </>
                            ))}
                        </div>
                        <Popover onClose={handleClose} open={open} anchorEl={anchorEl} data-testid="test-popover-list-options"
                            anchorOrigin={{ vertical: 'bottom', horizontal: 'left', }}
                            transformOrigin={{ vertical: 'top', horizontal: 'left', }} >
                            <div className="flex flex-col text-2">
                                <div>
                                    <div data-testid="test-menuItem-clone-list" onClick={() => { openModal('ClonePropertyList') }} role="button"
                                        className="p-4 flex flex-row space-x-2 hover:bg-gray-2 cursor-context-menu hover:bg-gray-15">
                                        <div>
                                            <FileCopy fontSize="small" />
                                        </div>
                                        <div className="pl-4">
                                            Clone
                                        </div>
                                    </div>
                                    {showDeleteOption && <div data-testid="test-menuItem-delete-list" onClick={() => { openModal('DeletePropertyList') }} role="button"
                                        className="p-4 flex flex-row space-x-2 hover:bg-gray-2 cursor-context-menu hover:bg-gray-15">
                                        <div>
                                            <Delete fontSize="small" />
                                        </div>
                                        <div className="pl-4">
                                            Delete
                                        </div>
                                    </div>}
                                </div>
                            </div>
                        </Popover>
                        <Modal ariaHideApp={false} isOpen={modalIsOpen} onRequestClose={closeModal}
                            closeTimeoutMS={500} style={customStyles} >
                            {selectedOption === "ClonePropertyList" ? <ClonePropertyList closeModal={closeModal} propertyDetailList={listData}></ClonePropertyList> :
                                <DeletePropertyList closeModal={closeModal} propertyDetailList={listData} setdisableClose={setdisableClose}></DeletePropertyList>}
                        </Modal>
                        {savedLists.filter(x => x.isCart).length === 0 &&
                            <div className="p-6 border-b-1 border-base">
                                You can Save a List.
                                <br />Come back here to load your saved list.
                            </div>
                        }
                    </div>
                </div>

                <div className="overflow-hidden ">

                </div>
            </div>

        </>
    )
}

export default SelectExistingList
